import React, { useEffect, useRef } from "react";
import { Box, Heading } from "rebass";
import { ULink } from "../components/ULink";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

interface IProps {
  title: string;
  to?: string | undefined;
  page: string;
  url?: string;
  discipline: string; 
  year: string;
  id: string;
  index: number;
}
const ProjectTitle = (props: IProps) => {
  const revealTitleRefs = useRef([null]);
  revealTitleRefs.current = [];
  useEffect(() => {
    revealTitleRefs.current.forEach((el) => {       
      gsap.fromTo(el, {
        autoAlpha: 0,
      }, {
        duration: 0.2, 
        autoAlpha: 1,
        ease: 'Power4.easeOut',
        scrollTrigger: {
          trigger: el,
          toggleActions: 'play none none reverse',
          scrub: 0.5,
        }
      });
    });
  }, []);
  
  const addTitleToRefs = (el: any) => {
    if (el && !revealTitleRefs.current.includes(el)) {
        revealTitleRefs.current.push(el);
    }
  };
  return (
    <Box variant="containerRelatedProject" ref={addTitleToRefs}>
      <Heading as="h2" variant="bigTitleS">
        <ULink
          {...props}
          to={props.page}
          activeClassName="active"
          sx={{
            variant: "links.imgLink",
            display: "block",
          }}
      >{props.title}
       </ULink>
      </Heading>
    </Box>
  );
};

export default ProjectTitle;
